import type { TrendItemAuth } from './trendItemAuth';
import type { TrendItemBasicInfo } from './trendItemBasicInfo';
import type { TrendItemContent } from './trendItemContent';
import type { TrendItemStats } from './trendItemStats';

export interface TrendItem {
  /** 인증 컨텍스트 정보 */
  auth?: TrendItemAuth;
  basicInfo?: TrendItemBasicInfo;
  /** 트렌드 관련 콘텐츠 */
  content?: TrendItemContent;
  /** 트렌드 통계 정보 */
  stats?: TrendItemStats;
}
